import gql from 'graphql-tag';

export const BUY_CREDITS_FORM_QUERY = gql`
  query buyCreditsFormQuery($accountId: ID!) {
    viewer {
      firstName
      lastName
    }
    account(id: $accountId) {
      type
      companyInformation {
        displayName
      }
      subscriptionInformation {
        payedBy
      }
      gpiRepresentativeData {
        parentAccountOwnerFullName
        parentAccountOwnerEmail
      }
    }
    creditValues(id: $accountId) {
      credit
      currencyValue
    }
    activeLocales
  }
`;

export const BUY_CREDITS_MUTATION = gql`
  mutation buyCreditsMutation($input: BuyCreditsInput!) {
    buyCredits(input: $input) {
      url
    }
  }
`;

export const SEND_PAYMENT_LINK_MUTATION = gql`
  mutation sendPaymentLinkMutation($input: SendPaymentLinkInput!) {
    sendPaymentLink(input: $input) {
      email
      amountOfCredits
    }
  }
`;
